import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
`;

const ModalContent = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  text-align: center;
`;

const ModalTitle = styled.h2`
  margin-top: 0;
  margin-bottom: 1rem;
`;

const ModalMessage = styled.p`
  margin-bottom: 2rem;
  line-height: 1.6;
  color: #555;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

const Button = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  min-width: 120px;

  &.confirm {
    background-color: #d9534f;
    color: white;
  }

  &.cancel {
    background-color: #f0f2f5;
    color: #333;
  }
`;

const ConfirmationModal = ({ isOpen, title, message, onConfirm, onCancel, confirmText = 'Yes', cancelText = 'No', children }) => {
    if (!isOpen) return null;

    return (
        <ModalOverlay onClick={onCancel}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <ModalTitle>{title}</ModalTitle>
                <ModalMessage>{message}</ModalMessage>
                <ButtonContainer>
                    {children ? (
                        children
                    ) : (
                        <><Button className="cancel" onClick={onCancel}>{cancelText}</Button>
                            <Button className="confirm" onClick={onConfirm}>{confirmText}</Button></>
                    )}
                </ButtonContainer>
            </ModalContent>
        </ModalOverlay>
    );
};

export default ConfirmationModal;